import { useFormikContext } from "formik";
import type { SaferFormikContextType } from "./SaferFormikContextType";

export const useSaferFormikContext = <FormValues>(): SaferFormikContextType<FormValues> => {
  return useFormikContext<FormValues>();
};
